import React, { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from './SettingsContext';

export const LocalizedTagContext = createContext();

export const LocalizedTagProvider = ({ children }) => {
  const { t } = useTranslation();
  const { settings, loading } = useSettings();

  const LocalizedTag = ({ tag = 'div', textKey, text, ...props }) => {
    const Tag = tag;
    let translatedText = '';

    if (textKey) {
      translatedText = t(textKey);
    } else if (text && typeof text === 'object') {
      translatedText = text[settings.defaultLanguage.toLowerCase()] || text.en || '';
    } else {
      translatedText = text || '';
    }

    return <Tag {...props}>{translatedText}</Tag>;
  };

  return (
    <LocalizedTagContext.Provider value={{ LocalizedTag, loading, language: settings.defaultLanguage }}>
      {children}
    </LocalizedTagContext.Provider>
  );
};

export const useLocalizedTag = () => useContext(LocalizedTagContext);